<template>
  <div class="admin-login-wrapper">
    <a-form-model
      :model="loginForm"
      ref="loginForm"
      :rules="rules"
      class="login-form"
    >
      <a-form-model-item prop="roleId">
        <a-select
          placeholder="用户类型"
          :size="formSize"
          v-model="loginForm.roleId"
        >
          <a-select-option
            v-for="role of adminRoles"
            :key="role.value"
            :value="role.value"
            >{{ role.label }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="userName">
        <a-input
          v-model.trim="loginForm.userName"
          placeholder="账户"
          :size="formSize"
        >
          <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="password">
        <a-input-password
          :size="formSize"
          v-model.trim="loginForm.password"
          type="password"
          placeholder="密码"
          @keypress.enter.native="handleSubmit"
        >
          <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
        </a-input-password>
      </a-form-model-item>
      <a-form-model-item prop="smsCode" class="random">
        <a-input
          class="random-input"
          :size="formSize"
          v-model.trim="loginForm.smsCode"
          type="text"
          placeholder="验证码"
          :maxLength="6"
        >
        </a-input>
        <a-button type="link" disabled v-if="show">{{ time }}秒后重试</a-button>
        <a-button
          type="link"
          :disabled="!(loginForm.userName && loginForm.roleId)"
          @click="getCode"
          v-else
        >
          获取验证码
        </a-button>
      </a-form-model-item>
      <!-- <a-form-model-item prop="code" class="random">
        <a-input
          class="random-input"
          :size="formSize"
          v-model.trim="loginForm.code"
          type="text"
          placeholder="验证码"
        >
        </a-input>
        <img class="code-img" :src="src" @click="refresh" alt="刷新重试" />
      </a-form-model-item> -->
      <a-form-model-item style="margin-bottom: 5px;">
        <a-button
          block
          type="primary"
          :size="formSize"
          @click="handleSubmit"
          :loading="loading"
        >
          登录
        </a-button>
      </a-form-model-item>
      <a-form-model-item>
        <div class="flex-j-b flex-a-c">
          <!-- <div>
            <a-checkbox v-model="privacy"></a-checkbox>
            <a
              style="margin-left:12px;"
              target="_blank"
              href="https://ntppc.oss-cn-shanghai.aliyuncs.com/国家基层儿科医护培训系统隐私声明.pdf"
              >隐私条款</a
            >
          </div> -->
          <div style="color:#8c8c8c;">
            登录即代表您已阅读并同意
            <router-link to="/privacy">《隐私声明》</router-link>
            <!-- <a
              target="_blank"
              href="https://ntppc.oss-cn-shanghai.aliyuncs.com/国家基层儿科医护培训系统隐私声明.pdf"
              class="yinsi"
              >《隐私申明》</a
            > -->
          </div>
          <a-button type="link" size="small" @click="handleForgetPassword">
            忘记密码
          </a-button>
        </div>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import rolesMixin from "@/mixins/roles";
import { sendCode } from "@/api/user.js";
import { showMessage } from "@/utils/message.js";

export default {
  mixins: [rolesMixin],
  data() {
    return {
      privacy: false,
      loginForm: {
        roleId: undefined,
        userName: "",
        password: "",
        grant_type: "password",
        smsCode: ""
        // code: "",
        // randomStr: ""
      },
      rules: {
        roleId: [
          {
            required: true,
            message: "请选择用户类型",
            trigger: "blur"
          }
        ],
        userName: [
          {
            required: true,
            message: "请输入账户",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur"
          }
        ],
        smsCode: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur"
          }
        ]
      },
      loading: false,
      src: "",
      show: false,
      time: 120,
      timer: null
    };
  },
  computed: {
    ...mapGetters(["formSize"])
  },
  // created() {
  // const url = process.env.VUE_APP_REQUEST_URL;
  // this.loginForm.randomStr =
  //   new Date().getTime() + "" + (Math.random() * 100).toFixed();
  // this.src = url + "/random/randomStr/" + this.loginForm.randomStr;
  // },
  methods: {
    ...mapActions({
      loginAddSmsCode: "loginAddSmsCode"
    }),
    handleForgetPassword() {
      this.$router.push({ name: "UpdatePassword" });
    },
    handleSubmit() {
      // if (!this.privacy) {
      //   return this.$message.error("请认真阅读并勾选隐私条款");
      // }
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true;
          this.loginAddSmsCode(this.loginForm)
            .then(res => {
              this.loading = false;
              if (res.user.defaultPwd === 1) {
                // 去重定向页
                if (this.$route.query.redirect) {
                  this.$router.push(this.$route.query.redirect);
                } else {
                  // 去首页
                  this.$router.push("/");
                }
              } else {
                this.$router.push({ name: "UpdatePwd" });
              }
            })
            .catch(e => {
              this.loading = false;
              console.error(e);
              // const url = process.env.VUE_APP_REQUEST_URL;
              // this.loginForm.randomStr =
              //   new Date().getTime() + "" + (Math.random() * 100).toFixed();
              // this.src = url + "/random/randomStr/" + this.loginForm.randomStr;
            });
        }
      });
    },
    async getCode() {
      const param = {
        userName: this.loginForm.userName,
        roleId: this.loginForm.roleId
      };
      let { code, message } = await sendCode(param);
      if (code == 1) {
        this.show = true;
        showMessage("success", message);
        this.timer = setInterval(() => {
          --this.time;
          if (this.time < 0) {
            clearInterval(this.timer);
            this.time = 0;
            this.show = false;
          }
        }, 1000);
      } else {
        showMessage("error", message);
      }
    }
    // refresh() {
    //   const url = process.env.VUE_APP_REQUEST_URL;
    //   this.loginForm.randomStr = new Date().getTime();
    //   this.src = url + "/random/randomStr/" + this.loginForm.randomStr;
    //   console.log(this.src);
    // }
  }
};
</script>
<style lang="less">
.random .ant-form-item-children {
  display: flex;
  justify-content: space-between;
}
</style>
<style lang="less" scoped>
.admin-login-wrapper {
  min-height: 280px;
  .login-form {
    width: 375px;
    padding: 0 5px;
    box-sizing: border-box;
    margin: 0 auto;
    // .random-input {
    //   width: 200px;
    // }
    .code-img {
      cursor: pointer;
    }
  }
  .yinsi {
    color: @primary-color;
  }
}
</style>
